import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/learn/volume.svg'
import DotsImage from '@assets/images/revise/dots.png'
import {Progress} from 'antd'

const ItemPhrase = ({data, handlePlayAudio, type}: any) => {
  // Lấy số ngày cần ôn lại cụm từ
  const getDate = (date: any) => {
    const currentDate = Date.now()
    const endDate = new Date(date).getTime()
    const timeDifference = endDate - currentDate
    const result = Math.ceil(timeDifference / (1000 * 60 * 60 * 24))
    return result
  }

  return (
    <Box
      m={{base: '8px', md: '16px'}}
      borderRadius={'16px'}
      cursor={'pointer'}
      _hover={{
        bg: '#E6F7FF',
      }}>
      <Flex
        p={{base: '8px', md: '16px'}}
        gap={{base: '12px', md: '16px'}}
        justifyContent={'space-between'}
        alignItems={'center'}>
        <Flex>
          <Progress type="circle" percent={data.percent_complete} size={40} />
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Flex alignItems={'center'} gap={'8px'}>
            <Text fontSize={{base: '14px', md: '16px'}}>{data.phrase}</Text>
            <Image src={DotsImage} />
            <Text fontSize={'12px'} color={'#8C8C8C'}>
              {`(${data.part_of_speech})`}
            </Text>
          </Flex>
          <Text fontSize={{base: '12px', md: '12px'}} color={'#8C8C8C'}>
            {data.meaning}
          </Text>
        </Flex>
        {type === 'complete' ? (
          <Text fontSize={{base: '12px', md: '16px'}} fontWeight={600}>
            {data?.suggest_date &&
              ` Ôn lại sau ${getDate(data?.suggest_date)} ngày`}
          </Text>
        ) : (
          <Center
            w={{base: '36px', md: '40px'}}
            h={{base: '36px', md: '40px'}}
            borderRadius={'50%'}
            border={'1px solid #FFC069'}
            flexShrink={0}
            onClick={() => handlePlayAudio(data.audio)}>
            <Image src={VolumeIcon} />
          </Center>
        )}
      </Flex>
    </Box>
  )
}

export default ItemPhrase
